import { motion } from "framer-motion";
import { Zap, ArrowRight } from "lucide-react";

const DEALS = [
  {
    title: "Adult Bike + Kids Helmet FREE",
    body: "Buy any adult bike (Sur-Ron or Talaria) and we throw in a kids motocross helmet, sized on delivery.",
    tag: "Family favourite",
  },
  {
    title: "Family Bundle",
    body: "One adult bike + one OSET kids bike: free protective gear set (pads + gloves) with the bundle.",
    tag: "Best value",
  },
  {
    title: "Pre-Order Bonus",
    body: "Every pre-order placed this month ships with a free bike cover. Just mention it on enquiry.",
    tag: "This month",
  },
];

export const DealsSection = () => {
  const go = (e) => {
    e.preventDefault();
    window.__lenis?.scrollTo("#contact", { offset: -70 });
  };

  return (
    <section id="deals" data-testid="deals-section" className="relative scroll-mt-24 border-t border-border bg-forest py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between"
        >
          <div>
            <p className="mono-label flex items-center gap-3">
              <span className="inline-block h-0.5 w-10 bg-volt" />
              Current Deals
            </p>
            <h2 className="mt-3 font-serif text-4xl font-black uppercase tracking-tight text-bone sm:text-5xl">
              Bundle <span className="text-volt">offers</span>
            </h2>
          </div>
          <p className="max-w-xs font-mono text-[10px] leading-relaxed tracking-[0.1em] text-sand/60 uppercase">
            Deals rotate regularly — confirm the current offer on enquiry
          </p>
        </motion.div>

        <div className="mt-12 grid gap-6 md:grid-cols-3">
          {DEALS.map((d, i) => (
            <motion.div
              key={d.title}
              data-testid={`deal-card-${i + 1}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
              className="group relative border border-volt/25 bg-forest-deep p-7 transition-colors duration-300 hover:border-volt/60"
            >
              <span className="inline-flex items-center gap-1.5 bg-volt px-2.5 py-1 font-mono text-[9px] font-bold tracking-[0.15em] text-forest-deep uppercase">
                <Zap className="h-3 w-3" strokeWidth={2.5} fill="currentColor" />
                {d.tag}
              </span>
              <h3 className="mt-5 font-serif text-2xl font-black uppercase leading-tight text-bone">
                {d.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-sand">{d.body}</p>
              <a
                href="#contact"
                data-testid={`deal-enquire-${i + 1}`}
                onClick={go}
                className="mt-6 inline-flex items-center gap-2 font-mono text-[10px] font-bold tracking-[0.18em] text-volt uppercase transition-colors group-hover:text-brass"
              >
                Claim on enquiry
                <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-1" />
              </a>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
